import React from 'react';
import { useAppState, ActionType } from '../../state/AppState';
import { VideoCameraTwoTone, AudioTwoTone } from '@ant-design/icons';

const EnableAV = () => {
  const { dispatch, enableAV } = useAppState();
  if (enableAV) {
    return <div />;
  }

  return (
    <div
      style={{
        position: 'absolute',
        paddingLeft: 69,
        right: 0,
        transform: 'translateX(100%)',
        height: '100%',
      }}>
      <div
        onClick={() => {
          dispatch({
            type: ActionType.ToggleAV,
            enabled: !enableAV,
          });
        }}
        className='div-button'
        style={{
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <p>Join the party!</p>
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <VideoCameraTwoTone twoToneColor='#ee008e' />
          <AudioTwoTone twoToneColor='#ee008e' />
        </div>
      </div>
    </div>
  );
};

export default EnableAV;
